import formButton from '@/components/common/form-button/form-button.vue'
import { mapActions } from 'vuex'
import store from '@/store'
import config from '@/config'

const redirectTo = (url) => {
  window.location.assign(url)
}

export default {
  components: {
    formButton
  },
  data() {
    return {
      loginMessage: '',
      mockEnabled: config.ENV === 'local'
    }
  },
  methods: {
    ...mapActions('countries', ['getCountriesList']),
    ...mapActions('competitionMechanic', ['getMechanicList']),
    ...mapActions('user', ['getUsers']),
    ...mapActions('auth', ['getExpirationTime']),
    ...mapActions(['resetState']),
    fetchData() {
      this.getCountriesList()
      this.getMechanicList()
      this.getUsers({})
      this.getExpirationTime()
    },
    onClickOkta() {
      redirectTo(config.API_URL + 'admin/login/okta')
    },
    onClickGoogle() {
      redirectTo(config.API_URL + 'admin/login/google')
    },
    onClickMock() {
      redirectTo(config.API_URL + 'admin/login/mock')
    }
  },
  created() {
    this.resetState()
  },
  beforeRouteEnter(to, from, next) {
    store.dispatch('app/getXCsrfToken')
    next()
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/page-login/page-login.js